export const defaultMaxVideoDuration = Infinity;

export const TERMS_CONDITION_CONSENT = "eu.consent-terms-conditions";
export const SHARE_EMAIL_CONSENT = "eu.consent-email";
export const LOGIN_COOKIE_CONSENT = "eu.consent-cookie";
